
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M78.192 29.002c.98 0 1.808-.829 1.808-1.808 0-.98-.829-1.808-1.808-1.808H63.578V14.388h14.614c.98 0 1.808-.829 1.808-1.808 0-.98-.829-1.808-1.808-1.808H63.578V1.808C63.578.828 62.75 0 61.77 0c-.979 0-1.808.829-1.808 1.808v8.964H41.808V1.808C41.808.828 40.979 0 40 0c-.98 0-1.808.829-1.808 1.808v8.964H20.038V1.808C20.038.828 19.209 0 18.23 0c-.98 0-1.808.829-1.808 1.808v8.964H1.808c-.98 0-1.808.829-1.808 1.808 0 .98.829 1.808 1.808 1.808h14.614v10.998H1.808c-.98 0-1.808.829-1.808 1.808 0 .98.829 1.808 1.808 1.808h14.614V34.5C6.177 35.405.678 41.356.452 41.58c-.301.302-.452.754-.452 1.206v35.405C0 79.172.829 80 1.808 80h76.384c.98 0 1.808-.829 1.808-1.808V42.787c0-.753-.452-1.431-1.13-1.657-.678-.301-1.507-.075-1.959.452-.075.075-4.82 4.896-13.258 5.876V29.002h14.54zM41.808 14.388h18.154v10.998H41.808V14.388zm18.154 14.614v18.606c-5.8-.075-11.902-2.034-18.154-5.65V29.003h18.154zM20.038 14.388h18.154v10.998H20.038V14.388zm18.154 14.614v10.847c-6.252-3.465-12.354-5.273-18.154-5.499v-5.423h18.154v.075zm38.192 47.382H3.616V43.541c1.506-1.432 6.855-5.575 15.367-5.575 6.177 0 12.806 2.11 19.736 6.328 7.458 4.67 14.84 6.93 21.77 6.93 7.383 0 12.731-2.561 15.895-4.67v29.83z"}}),_c('path',{attrs:{"d":"M19.5 50.161a3.616 3.616 0 10-6.176-3.76 3.616 3.616 0 006.177 3.76zM24.1 67.052a3.616 3.616 0 10-6.183-3.75 3.616 3.616 0 006.183 3.75zM35.1 58.139a3.616 3.616 0 10-1.654-7.04 3.616 3.616 0 001.654 7.04zM48.965 68.678a3.616 3.616 0 10-1.67-7.036 3.616 3.616 0 001.67 7.036zM66.472 63.86a3.616 3.616 0 10-4.313-5.804 3.616 3.616 0 004.313 5.805z"}})])
          )
        }
      }
    